import request from '@/utils/request'

let base = '/employee';
export const model_list = () => {
    return requ.get(base + '/bailian/model_list')
        .then(response => response)
};

export function send_vcode(phone) {
    return requ({
        method: 'get',
        url: base + '/anonymous/send_verification_code?phone=' + phone,
    })
}

export function user_login(params) {
    return request({
        method: 'post',
        url: '/login',
        params
    })
}

export const check_loginstatus = async (params) => {
    return request({
        method: 'post',
        url: '/user/check_loginstatus',
        params
    })
}

export function user_menus() {
    return request({
        method: 'post',
        url: '/user/menus'
    })
}

export function user_logout() {
    return requ({
        method: 'post',
        url: base + '/logout'
    })
}

export const user_info = () => {
    return requ.get(base + '/info')
        .then(response => response)
};

export const settle_count = () => {
    return requ.get(base + '/settle_count')
        .then(response => response)
};

export const describe_file = (fileId) => {
    return requ({
        method: 'get',
        url: base + '/file/describe_file?fileId=' + fileId,
    })
}

export const wxlogin_qrcode = () => {
    return requ.get(base + '/anonymous/wechat/qrcode')
        .then(response => response)
};

//封装post请求
export const postRequest = (url, params) => {
    return axios({
        method: 'post',
        url: base + url,
        data: params
    })
}

//封装get请求
export const getRequest = (url, params) => {
    return axios({
        method: 'get',
        url: base + url,
        data: params
    })
}

//封装put请求
export const putRequest = (url, params) => {
    return axios({
        method: 'put',
        url: base + url,
        data: params
    })
}

//封装delete请求
export const deleteRequest = (url, params) => {
    return axios({
        method: 'delete',
        url: base + url,
        data: params
    })
}